import {useMemo} from 'react'
import {UseMutationResult} from '@tanstack/react-query'
import {AxiosError, AxiosResponse} from 'axios'
import {UseFormReturn, useWatch} from 'react-hook-form'
import {ObjectKeys} from '@/utilities/helpers'
import {MedicalReportValidationSchema} from '../formSchemas'
import {HttpMedicalReportPayload} from '../http/medicalReports.http'
import {isReportTypeProjectCompliant} from '../utils'

export const useMedicalReportFormStatus = ({
    form,
    mutation
}: {
    form: UseFormReturn<MedicalReportValidationSchema>
    mutation: UseMutationResult<AxiosResponse, AxiosError, HttpMedicalReportPayload>
}): {
    isDisabled: boolean
    isPendingSubmit: boolean
    isPendingDraftSaving: boolean
    isDirty: boolean
} => {
    const project = useWatch({control: form.control, name: 'project'})
    const reportType = useWatch({control: form.control, name: 'reportType'})

    // Determine whether the selected reportType is compliant with the attached project
    const isTypeProjectCompliant = useMemo(
        () => isReportTypeProjectCompliant(reportType?.keyName, project),
        [project, reportType?.keyName]
    )

    return {
        isDisabled: !isTypeProjectCompliant,
        isPendingSubmit: mutation.isPending && mutation.variables.status == 'signed',
        isPendingDraftSaving: mutation.isPending && mutation.variables.status == 'draft',
        isDirty: mutation.status == 'idle' && ObjectKeys(form.formState.dirtyFields).length > 0
    }
}
